import { match } from 'react-router';

import mobileRootRoute from '../routes/mobileRoutes';
import rootRoute from '../routes/Routes';

/**
 * React Router v3 has no way of programmatically accessing
 * url params based on the configuration of our routes. Below is
 * the only available option which is suppose to be used to generate
 * server side routes.
 *
 * @Note: Due to the fact that this utility needs access to our route builder
 * we can not put this utility in the `Utils` namespace or it would result
 * in a circular dependency
 * @Note: This selector is actually asynchrounous (why? who knows) and therefore
 * requires this to be called as such.
 * @param {object} store - store object
 * @param {boolean} isMobileOrTablet - whether or not to use normal or mobile route builder
 * @returns {object} - an object containing props that match the current route
 */
export function getRouterParams(store: $TSFixMe, isMobileOrTablet: boolean): $TSFixMe {
  const rootGeneratorFunction = isMobileOrTablet ? mobileRootRoute : rootRoute;

  return new Promise((res, rej) => {
    match(
      {
        routes: rootGeneratorFunction(store, isMobileOrTablet),
        location: window.location,
      },
      (error, _redirectLocation, renderProps) => {
        if (error) {
          return rej(error);
        }
        if (renderProps) {
          return res(renderProps.params);
        }
        return res({});
      },
    );
  });
}
